/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import Table, { Column } from '../../components/Table';
import AddField, { getTag } from '../../utils/tableUtils';
import { TableRow } from './models';

interface BeneficiaryIncludeTableProps {
  dataTable: TableRow[];
  templateRowExpanded: (rowData: TableRow) => JSX.Element;
  rowExpanded: TableRow[];
  setRowExpanded: (rows: TableRow[]) => void;
  setPositionOfRowExpanded: (data: any) => void;
  setSelectedBeneficiary: (name: string) => void;
  setBeneficiary: React.Dispatch<React.SetStateAction<any[]>>;
}

export const BeneficiaryIncludeTable = ({
  dataTable,
  templateRowExpanded,
  rowExpanded,
  setRowExpanded,
  setPositionOfRowExpanded,
  setSelectedBeneficiary,
  setBeneficiary,
}: BeneficiaryIncludeTableProps) => {
  return (
    <Table
      items={dataTable}
      className="notiflix-table-loading"
      rowExpansionTemplate={templateRowExpanded}
      onRowToggle={(e) => setRowExpanded([e.data[e.data.length - 1]])}
      expandedRows={rowExpanded}
      onRowExpand={(e) =>
        window.innerWidth <= 768 && setPositionOfRowExpanded(e.originalEvent)
      }
      onRowClick={(e) => {
        setSelectedBeneficiary(e.data.beneficiaryName);
        setBeneficiary([]);

        if (
          rowExpanded.length > 0 &&
          rowExpanded[0]?.requestId !== e.data?.requestId
        ) {
          setRowExpanded([]);
          return setRowExpanded([e.data]);
        }
        return rowExpanded.length === 0
          ? setRowExpanded([e.data])
          : setRowExpanded([]);
      }}
    >
      <Column
        field="requestId"
        header="Solicitação"
        sortable
        body={(data) => AddField(data.requestId, 'Solicitação')}
      />
      <Column
        field="beneficiaryName"
        header="Beneficiário"
        sortable
        body={(data) => AddField(data.beneficiaryName, 'Beneficiário')}
      />
      <Column
        field="holderName"
        header="Nome do Titular"
        sortable
        body={(data) => AddField(data.holderName, 'Nome do Titular')}
      />
      <Column
        field="solicitationDate"
        header="Data de Solicitação"
        className="date"
        body={(data) => AddField(data.solicitationDate, 'Data de Solicitação')}
      />
      <Column
        field="status"
        header="Status"
        className="tag"
        sortable
        body={(data) => {
          switch (data.status) {
            case 'Aguardando análise Operadora':
              return getTag(
                'Status',
                'Aguard. Análi. Operadora',
                'orange',
                data.status,
              );
            case 'Aguardando preenchimento do Funcionário':
              return getTag(
                'Status',
                'Aguard. preen. Funcionário',
                'orange',
                data.status,
              );
            case 'Aguardando liberação':
              return getTag(
                'Status',
                'Aguard. Liberação',
                'orange',
                data.status,
              );
            case 'Contratação concluída':
              return getTag(
                'Status',
                'Contrat. Cocluída',
                'green',
                data.status,
              );
            case 'Em processo de finalização':
              return getTag(
                'Status',
                'Em Proces. Finalização',
                'orange',
                data.status,
              );
            case 'Solicitação com inconsistência':
              return getTag(
                'Status',
                'Solic. c/ Inconsistência',
                'orange',
                data.status,
              );
            case 'Solicitação em andamento':
              return getTag(
                'Status',
                'Solic. Em Andamento',
                'orange',
                data.status,
              );
            case 'Solicitação rejeitada pela operadora':
              return getTag('Status', 'Solic. Rejeitata', 'red', data.status);
            case 'Aguardando Análise da Declaração de Saúde':
              return getTag(
                'Status',
                'Aguard. Análi. Declar. Saúde',
                'orange',
                data.status,
              );
            case 'Solicitação cancelada':
              return getTag(
                'Status',
                'Solicitação cancelada',
                'gray',
                data.status,
              );
            default:
              return getTag(data.status, 'Indefinido', 'red', data.status);
          }
        }}
      />
      <Column expander headerStyle={{ width: '40px' }} />
    </Table>
  );
};
